import axios from "axios";
import {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../../Univ.js'
function EditRoomNo() {
    const {id} = useParams();
    const [room, setRoom] = useState([]);
    const [roomnoData, setRoomnoData] = useState({
        "room": '',
        "room_no": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-room-no/' + id + '/')
                .then(function (response) {
                    setRoomnoData({
                        room: response.data.room.id,
                        room_no: response.data.room_no,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        setRoomnoData({
            ...roomnoData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('room', roomnoData.room);
        _formData.append('room_no', roomnoData.room_no);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-room-no/' + id + '/', _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/room-no/');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        try {
            axios.get(baseUrl + 'room-type/')
                .then(function (response) {
                    setRoom(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Room No</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="room" className="form-label">Room</label>
                                    <select name="room" value={roomnoData.room} onChange={handleChange}
                                            className="form-control">
                                        {room.map((type, index) => {
                                            return <option key={index} value={type.id}>{type.room}
                                            </option>
                                        })}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="category" className="form-label">Room No</label>
                                    <input type="number" className="form-control" name="room_no"
                                           value={roomnoData.room_no}
                                           onChange={handleChange} id="room_no"/>
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditRoomNo;